import "./page-list.scss";

import * as React from "react";
import {cx}       from "emotion";

import {cs}    from "@Common/react/chain-services";
import {Types} from "@Common/types";
import {sort}  from "@Common/utils/collections";
import {chain} from "@Common/utils/fs";

export const PageList = ({state, pageCount, xdQaNamePrefix=undefined}:{
    pageCount       : number,
    state           : Types.Common.React.UseState.UseStateNext<number>,
    xdQaNamePrefix ?: string,
}) => cs(
    () => (
        <div className="page-list page-list-4sl">
            <button
                className={"prev"}
                onClick={() => state.onChange(state.value - 1)}
                disabled={state.value === 0}
                xd-qa-type="button"
                xd-qa-name={(xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"Previous Page"}
            >
                <i className="fa fa-angle-left" xd-qa-type="icon" xd-qa-name={(xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"Previous Page"}/>
            </button>

            <div className="list">
                {getPageList({
                    currentPage: state.value,
                    pageCount,
                }).map((page) => (
                    <button {...{
                        key: page.value,
                        className: cx("page", {active: page.active, reveal: page.reveal}),
                        onClick: () => state.onChange(page.value),
                        "xd-qa-type": "button",
                        "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"Page "+ (page.reveal ? page.value+1 : "-"),
                    }}>
                        {page.reveal ? (
                            page.value + 1
                        ) : (
                            "-"
                        )}
                    </button>
                ))}
            </div>

            <button
                className={"next"}
                onClick={() => state.onChange(state.value + 1)}
                disabled={state.value === pageCount - 1}
                xd-qa-type="button"
                xd-qa-name={(xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"Next Page"}
            >
                <i className="fa fa-angle-right" xd-qa-type="icon" xd-qa-name={(xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"Next Page"}/>
            </button>

        </div>
    ),
);



const getPageList = ({currentPage, pageCount}) => chain(
    [
        {
            value: 0,
            reveal: true,
        },
        ...[
            ...currentPage === pageCount - 1 ? [
                {
                    value: currentPage - 2,
                },
                {
                    value: currentPage - 1,
                    reveal: true,
                },
            ] : [
                {
                    value: currentPage - 1,
                },
            ],
            {
                value: currentPage,
                reveal: true,
                active: true,
            },
            ...currentPage === 0 ? [
                {
                    value: currentPage + 1,
                    reveal: true,
                },
                {
                    value: currentPage + 2,
                },
            ] : [
                {
                    value: currentPage + 1,
                },
            ],
        ],
        {
            value: pageCount - 1,
            reveal: true,
        },
    ],
    (_) => _.filter((e) => e.value > -1 && e.value < pageCount),
    (_) => unify(_, {
        by: (e) => e.value,
        merge: (o1, o2) => ({...o1, ...o2}),
    }),
    (_) => sort(_, (e) => e.value),
);

const unify = (col, {by, merge}) => {
    let ret = [];
    for (const e2 of col) {
        const i = ret.findIndex((e1) => by(e1) === by(e2));
        if (i === -1) {
            ret.push(e2);
        } else {
            const e1 = ret[i];
            ret[i] = merge(e1, e2);
        }
    }
    return ret;
};
